var _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKideApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .b { fill: none; stroke: #c16969; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5; } "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m16.5737,12.0609l2.3784-3.2827,2.4003,3.2817v11.5437l6.8166-6.7782h3.0406v3.1485l-8.4608,8.4132-3.1703.8447-3.0174-3.0005.0127-14.1705Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m19.5784,29.2318l8.6043,9.9894h3.2561s0-3.1346,0-3.1346l-7.9027-8.4824"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 24,
    cy: 24,
    r: 21.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKideApp);
export default __webpack_public_path__ + "static/media/kide_app.c07f14dd7588133214e51b4e73372d8a.svg";
export { ForwardRef as ReactComponent };